import { render } from "./ElemExam.vue?vue&type=template&id=4365cab7&scoped=true"
import script from "./ElemExam.vue?vue&type=script&lang=js"
export * from "./ElemExam.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=4365cab7&scoped=true&lang=css"
import "./ElemExam.vue?vue&type=style&index=1&id=4365cab7&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4365cab7"]])

export default __exports__